import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";
import { Loader } from "../../Shared/PageLoader";
import { useSelector } from "react-redux";

export default function ReportAssetScrapComponent(props) {
  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [assetScrapList, setAssetScrapList] = useState([]);
  const refDataGrid = useRef(null);
  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "Loading Report...",
  });

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Scrap`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));

      await getAssetScrapRequestLst(0, user?.userId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetScrapRequestLst = async (assetScrapId, userId) => {
    try {
      debugger;
      const response = await reportService.getAssetScrapList(
        assetScrapId,
        userId
      );
      setAssetScrapList(response.data ?? []);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetScrapList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      const idPrefix = `icon-${cellData?.data?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            {props?.featurePermission?.canView && (
                              <>
                                <span>
                                  <IconWithTooltip
                                    id={`${idPrefix}-view`}
                                    className="iconify-size mr-1"
                                    title="View asset scrap request"
                                    tooltip="View asset scrap request"
                                    icon="solar:document-text-outline"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate("/ViewAssetScrapRequest", {
                                        state: {
                                          stateData:
                                            cellData.data?._raw ??
                                            cellData.data,
                                          requestId: cellData.data?.id,
                                          isReport: true,
                                        },
                                      })
                                    }
                                  />
                                </span>
                              </>
                            )}
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetScrapRequestNo"
                    caption="Request No"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                  />
                  <Column
                    dataField="statusName"
                    caption="Status"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(e) => {
                      let color = "#28A745";
                      if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetScrapInDraftMode
                      )
                        color = "#ee0a0aff";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetScrapBackToDraft
                      )
                        color = "#ee0a0aff";
                      else if (
                        e.data?.statusId === AssetSubStatus.AssetScrapApproved
                      )
                        color = "#4CAF50";
                      else if (
                        e.data?.statusId ===
                        AssetSubStatus.AssetScrapSentForApproval
                      )
                        color = "#FF9800";

                      return (
                        <div>
                          <span style={{ color }}>{e.data?.statusName}</span>
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {e.data?.currentUserId > 0
                              ? e.data?.currentUserName
                              : e.data?.fromUserName}
                          </div>
                        </div>
                      );
                    }}
                  />
                  <Column
                    dataField="requestedDate"
                    caption="Request Date"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    dataType="date"
                    format={DefaultDateFormat.GridDayMonthYearDateFormat}
                  />
                  <Column
                    dataField="fromUserName"
                    caption="From"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserName ?? ""}</span>
                          {data?.data?.fromDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserName"
                    caption="To"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserName ?? ""}</span>
                          {data?.data?.toDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="projectName"
                    caption="Project"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.projectName ?? ""}</span>
                          {data?.data?.locationName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.locationName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  {/* <Column
                                dataField="subject"
                                caption="Subject"
                                allowSearch={true}
                                allowFiltering={false}
                                allowSorting={true}
                              /> */}
                  <Column
                    dataField="noOfAssets"
                    caption="No Of Assets"
                    allowSearch={true}
                    allowFiltering={false}
                    allowSorting={true}
                    alignment={"center"}
                  />
                  {/* <Column
                                dataField="note"
                                caption="Note"
                                allowSearch={true}
                                allowFiltering={false}
                                allowSorting={true}
                              /> */}
                  <Column
                    dataField="createdDate"
                    caption="Created On"
                    allowSearch={true}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.createdDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.createdDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.createdDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.createdByName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Column
                    dataField="updatedByName"
                    caption="Last Updated"
                    allowSearch={true}
                    allowFiltering={false}
                    cellRender={(data) => {
                      if (data?.data?.updatedByName) {
                        return (
                          <>
                            <span>{data?.data?.updatedByName ?? ""}</span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.toDepartmentName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetScrapRequestLst(0, user?.userId);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset Scrap Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
